<template>
  <div>
    <content-panel class="panel-tabs" v-if="isShowCommoditySales || isShowProductSales || isShowJDProductSalesTable">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="商品销量表" name="commoditySales" v-if="isShowCommoditySales"> </el-tab-pane>
        <el-tab-pane label="产品销量表" name="productSales" v-if="isShowProductSales"> </el-tab-pane>
        <el-tab-pane label="京东自营入仓产品销量表" name="JDProductSalesTable" v-if="isShowJDProductSalesTable"> </el-tab-pane>
        <!-- <el-tab-pane label="型号销量表" name="modelSalesTable"> </el-tab-pane> -->
      </el-tabs>
      <component :is="activeComponent"></component>
    </content-panel>
  </div>
</template>

<script>
import commoditySales from "./commoditySales/commoditySales";
import productSales from "./productSales/productSales";
import JDProductSalesTable from "./JDProductSalesTable/JDProductSalesTable";
import modelSalesTable from "./modelSalesTable/modelSalesTable";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: 'productSalesData1',
  // name: 'productSalesData',
  mixins: [pagePathMixin],
  components: { commoditySales, productSales, JDProductSalesTable, modelSalesTable },
  data() {
    return {
      activeName: "commoditySales",
      searchForm: {}
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
    permitList() {
      return JSON.parse(localStorage.getItem("permitList"))
    },
    isShowCommoditySales() {
      let Jurisdiction = "ec-pc-new$reportCenter$productSalesData$productSalesData$commoditySalesTable";
      return this.permitList.includes(Jurisdiction);
    },
    isShowProductSales() {
      let Jurisdiction = "ec-pc-new$reportCenter$productSalesData$productSalesData$productSalesTable";
      return this.permitList.includes(Jurisdiction);
    },
    isShowJDProductSalesTable() {
      let Jurisdiction = "ec-pc-new$reportCenter$productSalesData$productSalesData$jdWarehousingTab";
      return this.permitList.includes(Jurisdiction);
    }
  },
  // watch: {
  //   $route: {
  //     handler(val, olv) {
  //       var query = val.query ? val.query : {};
  //       console.log("🚀 ~ query:", query)
  //       if (olv.path == '/dataBoard/newProductStatistics' && (query.marketOnBegin != this.searchForm.marketOnBegin || query.marketOnEnd != this.searchForm.marketOnEnd) && this.isShowCommoditySales && JSON.stringify(val.query) != '{}') {
  //         this.searchForm = query
  //         this.activeName = 'commoditySales';
          
  //       } else if (olv.path == '/keyProductMonitoring' && query.bigModel && this.isShowProductSales) {
  //         this.activeName = 'productSales';
  //       }
  //     },
  //   },
  // },
  mounted() {
    let query = this.$route.query
    // this.searchForm = query
    if(query.bigModel && this.isShowProductSales) {
      this.activeName = 'productSales'
    }else {
      this.activeName = this.isShowCommoditySales ? 'commoditySales' : this.isShowProductSales ?  'productSales' : this.isShowJDProductSalesTable ? 'JDProductSalesTable' : ''
    }
    
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
</style>
